import { useTheme } from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import StyledSvg from '@sdk/components/ui/StyledSvg';
import DisplayText from '@sdk/components/ui/DisplayText';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import TimeIconSvg from '@web/assets/svg/Icons/32/time-gray.svg';
import CloseHeaderButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/CloseHeaderButton';
import {
  Header,
  HeaderButtons,
} from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalHeader/timesheetViewModalHeader.styles';

type Props = {
  onClose: () => void;
};
const CreateTimesheetModalHeader = ({ onClose }: Props) => {
  const theme = useTheme();

  return (
    <Header>
      <Row alignItems="center">
        <StyledSvg svg={TimeIconSvg} color={theme.colors[ThemeColorType.primary]} />
        <Row mLeft={12}>
          <DisplayText themeColor={ThemeColorType.primary} semiBold fontSize={18} lineHeight={24}>
            {gettext('New Timesheet')}
          </DisplayText>
        </Row>
      </Row>
      <HeaderButtons>
        <CloseHeaderButton onClick={onClose} />
      </HeaderButtons>
    </Header>
  );
};

export default CreateTimesheetModalHeader;
